import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

import ToastContent from "components/toast/ToastContent";
import { TOAST_CONFIG, TOAST_POSITION, TOAST_SEVERITY } from "static/constants";

/**
 * success toast message
 * @param
 */
export function showToast({
  message,
  position = TOAST_POSITION,
  type = TOAST_SEVERITY.SUCCESS,
}) {
  if (Array.isArray(message)) {
    message = message[0];
  }
  toast(ToastContent({ message, type }), {
    ...TOAST_CONFIG,
    position,
  });
}

export function showSuccessToast(message, options = {}) {
  showToast({ message, ...options });
}

export function showErrorToast(message = "Something Went Wrong", options = {}) {
  const { type = TOAST_SEVERITY.ERROR } = options;

  showToast({ message, ...options, type });
}

export const showToastWithUndo = (message, undoAction, isError, position) => {
  toast(
    ToastContent({
      message,
      type: isError ? TOAST_SEVERITY.ERROR : TOAST_SEVERITY.SUCCESS,
      undoAction,
    }),
    {
      ...TOAST_CONFIG,
      position,
      closeButton: <></>,
    }
  );
};
